import React, { useEffect, useState } from 'react';
import { Routes, Route, Link, useNavigate } from 'react-router-dom';
import api from '../services/api';
import SectionList from './admin/SectionList';
import SectionForm from './admin/SectionForm';
import ThemeSettings from './admin/ThemeSettings';
import UsersManager from './admin/UsersManager';

// ==== COMPONENTE: ADMIN HOME (DASHBOARD DE LEADS) ====
const AdminHome = () => {
  const userName = localStorage.getItem('user_name') || 'Administrador';
  const [leads, setLeads] = useState([]);
  const [filter, setFilter] = useState('all'); 
  const [loading, setLoading] = useState(true);
  
  const [selectedLead, setSelectedLead] = useState(null);
  const [replyMessage, setReplyMessage] = useState('');
  const [sending, setSending] = useState(false);

  useEffect(() => {
    fetchLeads();
  }, []);

  const fetchLeads = async () => {
    setLoading(true);
    try {
      const response = await api.get('/admin/leads'); 
      setLeads(response.data);
    } catch (error) {
      console.error("Erro ao buscar leads:", error);
    } finally {
      setLoading(false);
    }
  };

  const filteredLeads = leads.filter(lead => {
    if (filter === 'pending') return lead.status === 'pending';
    if (filter === 'replied') return lead.status === 'replied';
    return true; 
  });

  const handleOpenReply = (lead) => {
    setSelectedLead(lead);
    setReplyMessage(`Olá ${lead.name},\n\nObrigado pelo contato com o Jurerê Blue.\n\n`);
  };

  const handleSendReply = async () => {
    setSending(true);
    try {
      await api.post(`/admin/leads/${selectedLead.id}/reply`, { 
        message: replyMessage 
      });
      
      setLeads(leads.map(l => l.id === selectedLead.id ? { ...l, status: 'replied' } : l));
      setSelectedLead(null);
      alert('Resposta registrada com sucesso!');
    } catch (error) {
      console.error("Erro ao responder lead:", error);
      alert('Erro ao enviar resposta. Verifique a conexão.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="pb-5">
      <h3 className="fw-light mb-4 text-secondary">
        Bem-vindo ao Painel, <span className="fw-bold text-dark">{userName}</span>!
      </h3>

      <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-3">
        <div>
          <h4 className="fw-bold mb-0">Caixa de Entrada (Leads)</h4>
          <p className="text-muted small mb-0">Gerencie as mensagens recebidas pelo site.</p>
        </div>
        
        <div className="d-flex gap-3 text-center">
          <div className="bg-white p-2 px-3 rounded shadow-sm border">
            <h5 className="mb-0 fw-bold text-primary">{leads.length}</h5>
            <span className="small text-muted">Total</span>
          </div>
          <div className="bg-white p-2 px-3 rounded shadow-sm border border-danger">
            <h5 className="mb-0 fw-bold text-danger">{leads.filter(l => l.status === 'pending').length}</h5>
            <span className="small text-muted">Aguardando</span>
          </div>
        </div>
      </div>

      <div className="card shadow-sm border-0 mb-4">
        <div className="card-body p-3 d-flex justify-content-between align-items-center bg-white rounded">
          <div className="btn-group" role="group">
            <button type="button" className={`btn btn-sm ${filter === 'all' ? 'btn-dark' : 'btn-outline-dark'}`} onClick={() => setFilter('all')}>
              Todas
            </button>
            <button type="button" className={`btn btn-sm ${filter === 'pending' ? 'btn-danger' : 'btn-outline-danger'}`} onClick={() => setFilter('pending')}>
              Sem Resposta
            </button>
            <button type="button" className={`btn btn-sm ${filter === 'replied' ? 'btn-success' : 'btn-outline-success'}`} onClick={() => setFilter('replied')}>
              Respondidas
            </button>
          </div>
          <button className="btn btn-sm btn-outline-secondary" onClick={fetchLeads}>
            <i className="bi bi-arrow-clockwise me-1"></i> Atualizar
          </button>
        </div>
      </div>

      <div className="card shadow-sm border-0">
        <div className="table-responsive">
          <table className="table table-hover align-middle mb-0 bg-white">
            <thead className="table-light">
              <tr>
                <th>Status</th>
                <th>Data</th>
                <th>Nome / Contato</th>
                <th>Mensagem</th>
                <th className="text-end">Ação</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="5" className="text-center py-4">Carregando leads...</td></tr>
              ) : filteredLeads.length === 0 ? (
                <tr><td colSpan="5" className="text-center py-4 text-muted">Nenhuma mensagem encontrada.</td></tr>
              ) : (
                filteredLeads.map(lead => (
                  <tr key={lead.id} className={lead.status === 'pending' ? 'table-warning' : ''}>
                    <td>
                      {lead.status === 'pending' 
                        ? <span className="badge bg-danger">Pendente</span>
                        : <span className="badge bg-success">Respondida</span>
                      }
                    </td>
                    <td className="small text-muted">{lead.date}</td>
                    <td>
                      <div className="fw-bold">{lead.name}</div>
                      <div className="small text-muted"><i className="bi bi-envelope me-1"></i> {lead.email}</div>
                      <div className="small text-muted"><i className="bi bi-whatsapp me-1"></i> {lead.phone}</div>
                    </td>
                    <td>
                      <p className="mb-0 small text-truncate" style={{ maxWidth: '250px' }} title={lead.message}>
                        {lead.message}
                      </p>
                    </td>
                    <td className="text-end">
                      <button 
                        className={`btn btn-sm ${lead.status === 'pending' ? 'btn-primary' : 'btn-outline-secondary'}`}
                        onClick={() => handleOpenReply(lead)}
                      >
                        <i className={`bi ${lead.status === 'pending' ? 'bi-reply-fill' : 'bi-eye-fill'} me-1`}></i> 
                        {lead.status === 'pending' ? 'Responder' : 'Ver'}
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {selectedLead && (
        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-header bg-dark text-white">
                <h5 className="modal-title"><i className="bi bi-reply-fill me-2"></i>Responder Lead</h5>
                <button type="button" className="btn-close btn-close-white" onClick={() => setSelectedLead(null)}></button>
              </div>
              <div className="modal-body p-4">
                <div className="bg-light p-3 rounded border mb-4">
                  <div className="row">
                    <div className="col-md-6 mb-2"><strong>Nome:</strong> {selectedLead.name}</div>
                    <div className="col-md-6 mb-2"><strong>E-mail:</strong> {selectedLead.email}</div>
                    <div className="col-md-6 mb-2"><strong>Telefone:</strong> {selectedLead.phone}</div>
                    <div className="col-md-6 mb-2"><strong>Data:</strong> {selectedLead.date}</div>
                    <div className="col-12 mt-2">
                      <strong>Mensagem do Cliente:</strong>
                      <p className="mb-0 mt-1 fst-italic text-muted">"{selectedLead.message}"</p>
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label fw-bold">Sua Resposta (será enviada por e-mail):</label>
                  <textarea 
                    className="form-control" rows="6" 
                    value={replyMessage} onChange={(e) => setReplyMessage(e.target.value)}
                  ></textarea>
                </div>
              </div>
              <div className="modal-footer bg-light">
                <button type="button" className="btn btn-outline-secondary" onClick={() => setSelectedLead(null)}>Cancelar</button>
                <button type="button" className="btn btn-primary px-4" onClick={handleSendReply} disabled={sending}>
                  {sending ? 'Enviando...' : <><i className="bi bi-send-fill me-2"></i> Enviar</>}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ==== LAYOUT PRINCIPAL DO DASHBOARD ====
const Dashboard = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  
  const loggedUserEmail = localStorage.getItem('user_email') || ''; 
  const isMasterAdmin = loggedUserEmail.toLowerCase() === 'admin@jurereblue.com.br';

  // URL base unificada das telas do painel
  const CMS_BASE_URL = '/jb-acesso-master-control-cms';

  useEffect(() => {
    if (!token) {
      navigate('/jb-login-acesso-master-control-cms');
    }
  }, [token, navigate]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user_name');
    localStorage.removeItem('user_email');
    navigate('/jb-login-acesso-master-control-cms');
  };

  return (
    <div className="container-fluid">
      <div className="row">
        {/* Sidebar */}
        <nav className="col-md-3 col-lg-2 d-md-block bg-dark sidebar vh-100 p-3 text-white sticky-top">
          <h4 className="mb-4">CMS Jurerê</h4>
          <ul className="nav flex-column">
            <li className="nav-item mb-2">
              <Link to={`${CMS_BASE_URL}`} className="nav-link text-info fw-bold">
                <i className="bi bi-speedometer2 me-2"></i> Resumo
              </Link>
            </li>
            <li className="nav-item mb-2">
              <Link to={`${CMS_BASE_URL}/sections`} className="nav-link text-info fw-bold">
                <i className="bi bi-layout-text-window-reverse me-2"></i> Editar Onepage
              </Link>
            </li>
            <li className="nav-item mb-2 d-none">
              <Link to={`${CMS_BASE_URL}/blog`} className="nav-link text-info fw-bold">
                <i className="bi bi-journal-text me-2"></i> Posts do Blog
              </Link>
            </li>
            <li className="nav-item mb-2">
              <Link to={`${CMS_BASE_URL}/settings`} className="nav-link text-info fw-bold">
                <i className="bi bi-gear-fill me-2"></i> Configurações e Tema
              </Link>
            </li>
            
            {/* ITEM DA SIDEBAR CONDICIONAL */}
            {isMasterAdmin && (
              <li className="nav-item mb-2">
                <Link to={`${CMS_BASE_URL}/users`} className="nav-link text-info fw-bold">
                  <i className="bi bi-people-fill me-2"></i> Gerenciar Usuários
                </Link>
              </li>
            )}
            
            <hr />
            <li className="nav-item">
              <button onClick={handleLogout} className="btn btn-outline-danger btn-sm w-100">
                <i className="bi bi-box-arrow-right me-1"></i> Sair
              </button>
            </li>
          </ul>
        </nav>

        {/* Área de Conteúdo */}
        <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4 py-4 bg-light min-vh-100">
            <Routes>
                {/* CORRIGIDO: Removidas as barras iniciais das sub-rotas para funcionarem como caminhos relativos perfeitos */}
                <Route path="" element={<AdminHome />} />
                <Route path="sections" element={<SectionList />} />
                <Route path="sections/new" element={<SectionForm />} />
                <Route path="sections/edit/:id" element={<SectionForm />} />
                <Route path="settings" element={<ThemeSettings />} />
                
                {/* ROTA PROTEGIDA COM VALIDAÇÃO COMPLETA */}
                {isMasterAdmin ? (
                  <Route path="users" element={<UsersManager />} />
                ) : (
                  <Route path="users" element={
                    <div className="alert alert-danger mt-3 fw-bold">
                      <i className="bi bi-exclamation-triangle-fill me-2"></i>
                      Acesso negado. Esta área é exclusiva do administrador mestre do sistema.
                    </div>
                  } />
                )}
            </Routes>
        </main>
      </div>
    </div>
  );
};

export default Dashboard;